import { formatDate } from "module/main/util";
export var endpoints = [
    { value: "PROPERTY", label: "Property Lookup" },
    { value: "PROPERTY_APN", label: "APN Property Lookup" },
    { value: "PROPERTY_DETAILS", label: "Property Details" },
    { value: "PERSON", label: "Person Lookup" },
    { value: "BUSINESS", label: "Business Lookup" },
    { value: "DNC", label: "DNC Status" },
    { value: "REVERSE_PHONE", label: "Reverse Phone" },
];
export function endpointLabel(endpoint) {
    var _a, _b;
    return (_b = (_a = endpoints.find(function (item) { return item.value === endpoint; })) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : endpoint;
}
export function actionStatusTone(status) {
    switch (status) {
        case "COMPLETED":
            return "green";
        case "FAILED":
            return "red";
        case "PAUSED":
            return "yellow";
        case "RUNNING":
        case "QUEUED":
            return "blue";
        case "CREATED":
        default:
            return "gray";
    }
}
export function actionStatusClassName(status) {
    switch (status) {
        case "RUNNING":
            return "animate-pulse shadow-[0_0_20px_rgba(59,130,246,0.35)]";
        default:
            return "";
    }
}
export function actionCanPause(action) {
    return action.status === "QUEUED" || action.status === "RUNNING";
}
export function actionCanResume(action) {
    return action.status === "PAUSED";
}
export function actionCanRetryFailed(action) {
    return action.status === "COMPLETED" && action.failedCount > 0;
}
export function actionExportIsRunning(action) {
    return action.exportStatus === "QUEUED" || action.exportStatus === "RUNNING";
}
export function actionCanExport(action) {
    return (action.totalRows > action.pendingCount &&
        !["QUEUED", "RUNNING", "PAUSED"].includes(action.status) &&
        !actionExportIsRunning(action));
}
export function actionCanDownload(action) {
    return (Boolean(action.resultObjectKey) &&
        (action.exportStatus === "COMPLETED" || !action.exportStatus || action.exportStatus === "NONE"));
}
export function fileImportActivity(fileImport) {
    var _a;
    var actions = (_a = fileImport.actions) !== null && _a !== void 0 ? _a : [];
    if (!actions.length)
        return "ready";
    if (actions.some(function (action) { return ["QUEUED", "RUNNING"].includes(action.status) || actionExportIsRunning(action); })) {
        return "processing";
    }
    if (actions.some(function (action) { return action.status === "PAUSED"; }))
        return "paused";
    if (actions.some(function (action) { return action.status === "FAILED"; }))
        return "failed";
    if (actions.every(function (action) { return action.status === "COMPLETED"; }))
        return "complete";
    return "ready";
}
export function fileImportActivityTone(activity) {
    switch (activity) {
        case "complete":
            return "green";
        case "processing":
            return "blue";
        case "paused":
            return "yellow";
        case "failed":
            return "red";
        case "ready":
        default:
            return "gray";
    }
}
export function fileImportHasRunningishAction(fileImport) {
    var _a;
    return ((_a = fileImport.actions) !== null && _a !== void 0 ? _a : []).some(function (action) {
        return ["QUEUED", "RUNNING", "PAUSED"].includes(action.status) || actionExportIsRunning(action);
    });
}
export function fileImportDate(value) {
    return formatDate(value, true) || "Unknown date";
}
export function apiKeyLabel(apiKey) {
    var isCustom = apiKey.monthlyAllocation === null;
    var keyType = String(apiKey.keyType).toUpperCase();
    var status = apiKey.isActive ? "active" : "disabled";
    var tries = !isCustom ? "".concat(apiKey.triesLeft, " tries left, ") : "";
    return "".concat(keyType, " - ").concat(apiKey.id.substring(0, 8), " (").concat(tries).concat(status, ")");
}
export function estimateRows(fileImport, rowScope) {
    var _a;
    if (!fileImport)
        return 0;
    if (rowScope.mode === "all")
        return fileImport.rowCount;
    var rangedRows = ((_a = rowScope.ranges) !== null && _a !== void 0 ? _a : []).reduce(function (sum, range) { return sum + Math.max(0, range.end - range.start + 1); }, 0);
    return Math.min(fileImport.rowCount, rangedRows);
}
export function hasDncAddon(subscription) {
    var _a;
    return !!((_a = subscription === null || subscription === void 0 ? void 0 : subscription.addOns) === null || _a === void 0 ? void 0 : _a.some(function (addOn) { return addOn.id.includes("dnc"); }));
}
export function getUsageWarning(_a) {
    var _b;
    var activeImport = _a.activeImport, estimatedRows = _a.estimatedRows, selectedApiKeyInfo = _a.selectedApiKeyInfo, autoRechargeBlockId = _a.autoRechargeBlockId, hasSubscription = _a.hasSubscription;
    if (!activeImport || !selectedApiKeyInfo)
        return null;
    var triesLeft = (_b = selectedApiKeyInfo.triesLeft) !== null && _b !== void 0 ? _b : 0;
    if (triesLeft >= estimatedRows)
        return null;
    var keyType = String(selectedApiKeyInfo.keyType).toUpperCase();
    if (keyType === "TEST" && !hasSubscription) {
        return "This test key has ".concat(triesLeft, " hits left, but this action may run ").concat(estimatedRows, " rows. Upgrade to a live subscription before processing the full file.");
    }
    // eslint-disable-next-line eqeqeq
    if (selectedApiKeyInfo.monthlyAllocation != null && !autoRechargeBlockId) {
        return "This key has ".concat(triesLeft, " hits left, but this action may run ").concat(estimatedRows, " rows. Buy a usage block or enable auto top-up to avoid partial processing.");
    }
    return null;
}
